import styled from 'styled-components';
import { PageBreadcrumbMixin } from '../../mixins/components/PageBreadcrumbMixin';
import { PageContent } from '../PageContent/PageContent';
export var StyledPageBreadcrumb = /*#__PURE__*/styled(PageContent).withConfig({
  displayName: "StyledPageBreadcrumb",
  componentId: "c11n-8-111-1__sc-spmldi-0"
})(["", ""], PageBreadcrumbMixin);